import { TypeScrollBookmarkFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import ScrollBookmark from './ScrollBookmark'

const ContentfulScrollBookmark = withContentful<TypeScrollBookmarkFields>(ScrollBookmark)

export default ContentfulScrollBookmark
